import $ from 'jquery';

$(document).ready(function () {
  var filterLinks = $('.btn-mbic-filter');
  filterLinks.on('click', function (evt) {
    var clickedFilterLink = $(this);
    var clickedValue = clickedFilterLink.text().trim();
    if (clickedValue) {
      evt.preventDefault();
      $('.brandhub-thumb-item[data-filter-value]').each(function () {
        var item = $(this);
        if (item.attr('data-filter-value') === clickedValue) {
          item.css({ 'display': '' });
        } else {
          item.css({ 'display': 'none' });
        }
      });

      var gridBlock = $('.brandhub-thumb-item[data-filter-value]').first().closest('.brandhub-grid-block');
      gridBlock.find('img').lazyLoadXT();
      setTimeout(function () {
        $('html, body').animate({
          'scrollTop': gridBlock.offset().top - $('header').height()
        }, 500);
      }, 0);
    }
  });
});



// WEBPACK FOOTER //
// ./src/components/gridfilter/gridfilter.js